import AgendaMailOptionStore from './schema/AgendaMailOptionStore';
import RequestStatus from './schema/RequestStatus';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

const getStore = createStore<AgendaMailOptionStore>('agendaMailOptionStore', {
    serverCalendarFolders: [],
    isAgendaMailEnabled: false,
    agendaMailDisabledMap: new ObservableMap<string, boolean>(),
    getCalendarFoldersServiceStatus: RequestStatus.NotInitialized,
});

export const agendaMailStore = getStore();
export default getStore;
